import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";
import Login from "@/views/Login.vue";
import Sources from "@/views/Sources.vue";
import Avatars from "@/views/Avatars.vue";
import Account from "@/views/Account.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/login",
    name: "login",
    component: Login,
  },
  {
    path: "/sources",
    name: "sources",
    component: Sources,
  },
  {
    path: "/avatars",
    name: "avatars",
    component: Avatars,
  },
  {
    path: "/account",
    name: "account",
    component: Account,
  },
  { path: '/:pathMatch(.*)*', name: 'sources', component: Sources },

  // { path: "*", redirect: "/sources" }


];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
